import { render, staticRenderFns } from "./HorseCreationTriggered.vue?vue&type=template&id=405bd264&"
import script from "./HorseCreationTriggered.vue?vue&type=script&lang=js&"
export * from "./HorseCreationTriggered.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports